import { transcript_translations } from 'js/src/data/translated-editors/translated-editors-reducers';

/* MODULE EXPORTS */
export * from 'js/src/data/translated-editors/translated-editors-actions';
export * from 'js/src/data/translated-editors/translated-editors-selectors';
export * from 'js/src/data/translated-editors/translated-editors-types';

export default transcript_translations;
